<template lang="pug">
  div
    template(v-if="isFetching")
      v-skeleton-loader.mt-4(type="list-item-three-line")
      v-skeleton-loader.mt-4(type="list-item-three-line")
      v-skeleton-loader.mt-4(type="list-item-three-line")
      v-skeleton-loader.mt-4(type="list-item-three-line")
    template(v-else)
      v-card.pa-6.mt-4.round-xl(outlined)
        v-row.align-center
          v-col(cols="10")
            div.text-md.font-semibold.neutral700--text I want to have thank you message for this offer
            .text-sm.neutral700--text(style="margin-top: 2px;") By enabling this, it allows you to send thank you message to your customer after the offer is redeemed or after the end of the campaign or after specific date and time.
          v-spacer
          v-col.shrink
            div.justify-end
              y-switch.mb-n2(v-model="isEnabled")
      template(v-if="isEnabled")
        // SMS delivery
        sms-thank-message-delivery.mt-4(ref="smsOffer" :blast-data="thanks[0].data")
        // Email delivery
        email-thank-message-delivery.mt-4(ref="emailOffer" :blast-data="thanks[1].data")
        // Whatsapp delivery
        whatsapp-thank-message-delivery.mt-4(ref="whatsappOffer" :blast-data="thanks[2].data")
</template>

<script>
import SmsThankMessageDelivery from "@/components/clinic/marketing/SmsThankMessageDelivery.vue";
import EmailThankMessageDelivery from "@/components/clinic/marketing/EmailThankMessageDelivery.vue";
import WhatsappThankMessageDelivery from "@/components/clinic/marketing/WhatsappThankMessageDelivery.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    WhatsappThankMessageDelivery, EmailThankMessageDelivery, SmsThankMessageDelivery
  },
  data () {
    return {
      isFetching: false,
      isEnabled: false,
      thanks: [
        { method: 'sms', data: null },
        { method: 'email', data: null },
        { method: 'whatsapp', data: null },
      ],
    }
  },
  async mounted () {
    await this.fetchDeliverance()
    this.isEnabled = this.storedOffer.thankyou_msg_enabled
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchDeliverance () {
      this.isFetching = true
      return this.$axios.get(`/marketing/${this.company.slug}/offers/${this.storedOffer.id}/blasts`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.length) {
            this.$store.commit('marketing/setBlasts', blasts)
          }
          if (blasts.find(f => f.method === 'sms' && f.type === 'thank_you')) {
            let data = blasts.find(f => f.method === 'sms' && f.type === 'thank_you')
            let thank = this.thanks.find(f => f.method === 'sms')
            this.$set(thank, 'data', data)
          }
          if (blasts.find(f => f.method === 'email' && f.type === 'thank_you')) {
            let data = blasts.find(f => f.method === 'email' && f.type === 'thank_you')
            let thank = this.thanks.find(f => f.method === 'email')
            this.$set(thank, 'data', data)
          }
          if (blasts.find(f => f.method === 'whatsapp' && f.type === 'thank_you')) {
            let data = blasts.find(f => f.method === 'whatsapp' && f.type === 'thank_you')
            let thank = this.thanks.find(f => f.method === 'whatsapp')
            this.$set(thank, 'data', data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    validateData () {
      const isValidSms = this.$refs.smsOffer.validateData()
      const isValidEmail = this.$refs.emailOffer.validateData()
      const isValidWhatsapp = this.$refs.whatsappOffer.validateData()
      return isValidSms && isValidEmail && isValidWhatsapp
    },
    async saveData (quit) {
      await this.saveThankYouEnabled()
      if (!this.isEnabled) {
        quit ? this.$emit('quit') : this.$emit('updated')
        return
      }
      const isValid = this.validateData()
      if (!isValid) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        this.$emit('error')
        return
      }
      const savingAll = [
        this.$refs.smsOffer.saveData(),
        this.$refs.emailOffer.saveData(),
        this.$refs.whatsappOffer.saveData()
      ]
      try {
        await Promise.all(savingAll)
        if (quit) {
          this.$emit('quit')
          return
        }
        this.reset()
        this.$emit('updated')
      } catch (err) {
        await this.fetchDeliverance()
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) {
              message = data
            }
          }
        }
        this.showMessage(['error', message])
        this.$emit('error')
      }
    },
    saveThankYouEnabled () {
      return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.storedOffer.id}`, { thankyou_msg_enabled: this.isEnabled })
    },
    reset () {
      this.fetchDeliverance()
    },
  },
}
</script>

<style scoped>
</style>